<template>
  <div :key="isLiveMonitoring">
    <div v-if="!isLiveMonitoring" class="card card-shadow p-2 mb-2"
         :key="deviceData.refresh + deviceData.videoPathRefresh + deviceData.liveRefresh">
      <div class="columns pl-2 pr-2 pt-1 pb-0">
        <div class="column is-2 ml-2">
          <div class="is-size-7 has-text-grey-light has-text-weight-normal">Site name</div>
          <div class="has-text-black has-text-weight-bold">{{ deviceData.siteName }}</div>
        </div>
        <div class="column is-1 m-0">
          <div class="is-size-7 has-text-grey-light has-text-weight-normal">Device</div>
          <div class="has-text-black has-text-weight-bold">{{ deviceData.name }}</div>
        </div>
        <hr class="mt-3 mb-4 has-background-grey-lighter mr-0" style="width: 1px; height: 48px">
        <div class="column m-0 ml-2 pl-1 pr-1" style="width: 110px; max-width: 110px" @click="onChooseModelClick"
             v-if="!deviceData.dataRequired">
          <div class="has-text-centered p-1"
               :class="[isChooseModelEditOrAddAllowed(deviceData) && isProcessingPeriodsExists() ? 'clickable-info-editable' : 'clickable-info']">
            <div class="is-size-7 has-text-grey has-text-weight-normal">AI Model</div>
            <b-icon
                :type="deviceData.tasks && deviceData.tasks.model && deviceData.tasks.model.modelName ? 'is-primary' : 'is-danger'"
                :icon="deviceData.tasks && deviceData.tasks.model && deviceData.tasks.model.modelName ? 'check-circle' : 'close-circle'"
                size="is-small"></b-icon>
          </div>
        </div>
        <div class="column m-0 ml-2 pl-1 pr-1" style="width: 110px; max-width: 110px" @click="onSetPipelineClick"
             v-if="!deviceData.tasks || deviceData.tasks.length === 0 || deviceData.dataRequired ">
          <div class="has-text-centered p-1"
               :class="[isPipelineEditOrAddAllowed(deviceData) && isProcessingPeriodsExists() ? 'clickable-info-editable' : 'clickable-info']">
            <div class="is-size-7 has-text-grey has-text-weight-normal">Live pipeline</div>
            <b-icon
                :type="deviceData.dataRequired ? 'is-primary' : 'is-danger'"
                :icon="deviceData.dataRequired ? 'check-circle' : 'close-circle'"
                size="is-small"></b-icon>
          </div>
        </div>
        <div class="column m-0 ml-2 pl-1 pr-1" style="width: 110px; max-width: 110px" @click="onProcessingClick">
          <div class="has-text-centered p-1"
               :class="[isProcessingEditOrAddAllowed(deviceData) ? 'clickable-info-editable' : 'clickable-info']">
            <div class="is-size-7 has-text-grey has-text-weight-normal">Processing time</div>
            <b-icon
                :type="deviceData.processingPeriods && deviceData.processingPeriods.length > 0 ? 'is-primary' : 'is-danger'"
                :icon="deviceData.processingPeriods && deviceData.processingPeriods.length > 0 ? 'check-circle' : 'close-circle'"
                size="is-small"></b-icon>
          </div>
        </div>
        <div class="column m-0 pl-1 pr-1" style="width: 110px; max-width: 110px" @click="onVideoCalibrationClick">
          <div class="has-text-centered p-1"
               :class="[isEditOrAddAllowed(deviceData) ? 'clickable-info-editable' : 'clickable-info']">
            <div class="is-size-7 has-text-grey has-text-weight-normal">Video Config</div>
            <b-icon
                :type="isVideoCalibrationExists() ? 'is-primary' : 'is-danger'"
                :icon="isVideoCalibrationExists() ? 'check-circle' : 'close-circle'"
                size="is-small"></b-icon>
          </div>
        </div>
        <hr class="mt-3 mb-4 has-background-grey-lighter mr-0" style="width: 1px; height: 48px">
        <full-validation-info ref="fullValidation"
                              v-if="deviceData.initialValidationData && deviceData.initialValidationData.fullTasks"
                              :initial-validation="deviceData.initialValidationData"
                              :data-device-live-processing-data="deviceData.dataRequired"
                              :refreshing="deviceData.refresh"
                              @onShowFullResults="onShowFullResults"
                              @onShowInitialResults="onShowInitialResults"
                              @onRunFullProcessing="onRunFullProcessing"
                              @onResetStep="onResetStep"
                              @onShowError="onShowError"
                              @onRunTasksClick="onRunTasksVehProcessingClick">

        </full-validation-info>
        <tasks-info ref="vehicleValidation" v-else
                    :device-data="deviceData" :refreshing="deviceData.videoPathRefresh"
                    @onProcessingClick="onProcessingClick"
                    @onRunTasksClick="onRunTasksClick"
                    @onAddTasksClick="onAddTasksClick" @onRunInitialValidation="onRunInitialValidation"
                    @onResetStep="onResetStep" @onShowError="onShowError"></tasks-info>
      </div>
    </div>
    <b-collapse
        v-else
        class="card card-shadow mb-2"
        animation="slide"
        v-model="isOpen"
        style="border-radius: 8px; background-color: #f9f9f9;"
        aria-id="contentIdForA11y3">
      <template #trigger >
        <div
            class="card-header card-shadow"
            role="button"
            aria-controls="contentIdForA11y3"
            style="border-radius: 8px; background-color: white; height: 72px;">
          <div class="card-header-title">
            <div class="columns m-0 p-0 is-flex" style="width: 100%">
              <div class="column is-2 ml-2">
                <div class="is-size-7 has-text-grey-light has-text-weight-normal">Site name</div>
                <div class="has-text-black has-text-weight-bold">{{ deviceData.siteName }}</div>
              </div>
              <div class="column is-1 m-0" style="margin-left: 8px !important;margin-right: 4px !important;">
                <div class="is-size-7 has-text-grey-light has-text-weight-normal">Device</div>
                <div class="has-text-black has-text-weight-bold">{{ deviceData.name }}</div>
              </div>
              <hr class="mt-3 mb-4 has-background-grey-lighter mr-0" style="width: 1px; height: 48px">
              <div class="column m-0 ml-2 pl-1 pr-1" style="width: 110px; max-width: 110px" @click.stop="onChooseModelClick"
                   v-if="!deviceData.dataRequired">
                <div class="has-text-centered p-1"
                     :class="[isChooseModelEditOrAddAllowed(deviceData) && isProcessingPeriodsExists() ? 'clickable-info-editable' : 'clickable-info']">
                  <div class="is-size-7 has-text-grey has-text-weight-normal">AI Model</div>
                  <b-icon
                      :type="deviceData.tasks && deviceData.tasks.model && deviceData.tasks.model.modelName ? 'is-primary' : 'is-danger'"
                      :icon="deviceData.tasks && deviceData.tasks.model && deviceData.tasks.model.modelName ? 'check-circle' : 'close-circle'"
                      size="is-small"></b-icon>
                </div>
              </div>
              <div class="column m-0 ml-2 pl-1 pr-1" style="width: 110px; max-width: 110px" @click.stop="onSetPipelineClick"
                   v-if="!deviceData.tasks || deviceData.tasks.length === 0 || deviceData.dataRequired ">
                <div class="has-text-centered p-1"
                     :class="[isPipelineEditOrAddAllowed(deviceData) && isProcessingPeriodsExists() ? 'clickable-info-editable' : 'clickable-info']">
                  <div class="is-size-7 has-text-grey has-text-weight-normal">Live pipeline</div>
                  <b-icon
                      :type="deviceData.dataRequired ? 'is-primary' : 'is-danger'"
                      :icon="deviceData.dataRequired ? 'check-circle' : 'close-circle'"
                      size="is-small"></b-icon>
                </div>
              </div>
              <div class="column m-0 ml-2 pl-1 pr-1" style="width: 110px; max-width: 110px" @click.stop="onProcessingClick">
                <div class="has-text-centered p-1"
                     :class="[isProcessingEditOrAddAllowed(deviceData) ? 'clickable-info-editable' : 'clickable-info']">
                  <div class="is-size-7 has-text-grey has-text-weight-normal">Processing time</div>
                  <b-icon
                      :type="deviceData.processingPeriods && deviceData.processingPeriods.length > 0 ? 'is-primary' : 'is-danger'"
                      :icon="deviceData.processingPeriods && deviceData.processingPeriods.length > 0 ? 'check-circle' : 'close-circle'"
                      size="is-small"></b-icon>
                </div>
              </div>
              <div class="column m-0 pl-1 pr-1" style="width: 110px; max-width: 110px" @click.stop="onVideoCalibrationClick">
                <div class="has-text-centered p-1"
                     :class="[isEditOrAddAllowed(deviceData) ? 'clickable-info-editable' : 'clickable-info']">
                  <div class="is-size-7 has-text-grey has-text-weight-normal">Video Config</div>
                  <b-icon
                      :type="isVideoCalibrationExists() ? 'is-primary' : 'is-danger'"
                      :icon="isVideoCalibrationExists() ? 'check-circle' : 'close-circle'"
                      size="is-small"></b-icon>
                </div>
              </div>
              <hr class="mt-3 mb-4 has-background-grey-lighter mr-0" style="width: 1px; height: 48px">
              <div class="column m-0 pl-1 pr-1" style="width: 128px; max-width: 128px;">
                <div class="p-1 clickable-info-editable">
                  <div class="is-size-7 has-text-grey has-text-weight-normal">Num of files: <span class="has-text-weight-semibold">{{numOfConditionedFiles}}</span></div>
                  <div class="has-text-grey has-text-weight-normal" style="line-height: 1; font-size: 10px">Last file at:</div>
                  <div class="is-size-7 has-text-grey has-text-weight-normal" style="line-height: 1; margin-bottom: 2px"><span class="has-text-weight-semibold">{{latestFileTime}}</span></div>
                </div>
              </div>
              <hr class="mt-3 mb-4 has-background-grey-lighter mr-0" style="width: 1px; height: 48px">
              <div class="column m-0 pl-0 pr-0" style="width: 100%">
                <live-processing-info ref="liveProcessing"
                                      :live-processing-device-data="deviceData.liveProcessingDeviceData"
                                      :device-data="deviceData"
                                      :refreshing="deviceData.liveRefresh"
                                      @click.native.stop=""
                                      @onTriggerBackProcessing="onTriggerBackProcessing"
                ></live-processing-info>
              </div>
            </div>
          </div>
          <a class="card-header-icon" style="padding-left: 0">
            <b-icon
                :icon="isOpen ? 'chevron-down' : 'chevron-up'">
            </b-icon>
          </a>
        </div>
      </template>

      <div class="card-content">
        <div class="content">
          <div class="columns mt-0 mb-2 pt-0 pb-0" v-if="deviceData.liveProcessingDeviceData && lyraSet">
            <simple-tasks-info class="column mt-0 mb-0 pt-0 pb-0" :tasks="deviceData.liveProcessingDeviceData.lyraTasks" :property-set="lyraSet" @onShowError="onShowError"/>
            <b-icon icon="arrow-right-thick" class="mt-auto mb-auto"></b-icon>
            <simple-tasks-info class="column mt-0 mb-0 pt-0 pb-0" :tasks="deviceData.liveProcessingDeviceData.velaWithLyraTasks" :property-set="velaSet" @onShowError="onShowError"/>
            <b-icon icon="arrow-right-thick" class="mt-auto mb-auto"></b-icon>
            <simple-tasks-info class="column mt-0 mb-0 pt-0 pb-0" :tasks="deviceData.liveProcessingDeviceData.processingEventsTasks" :property-set="eventProcessingSet" @onShowError="onShowError"/>
          </div>
          <div class="columns mt-0 mb-2 pt-0 pb-0" v-else-if="deviceData.liveProcessingDeviceData && yoloSet">
            <simple-tasks-info class="column mt-0 mb-0 pt-0 pb-0" :tasks="deviceData.liveProcessingDeviceData.yoloTasks" :property-set="yoloSet" @onShowError="onShowError"/>
            <b-icon icon="arrow-right-thick" class="mt-auto mb-auto"></b-icon>
            <simple-tasks-info class="column mt-0 mb-0 pt-0 pb-0" :tasks="deviceData.liveProcessingDeviceData.velaWithYoloTasks" :property-set="velaSet" @onShowError="onShowError"/>
            <b-icon icon="arrow-right-thick" class="mt-auto mb-auto"></b-icon>
            <simple-tasks-info class="column mt-0 mb-0 pt-0 pb-0" :tasks="deviceData.liveProcessingDeviceData.processingEventsTasks" :property-set="eventProcessingSet" @onShowError="onShowError"/>
          </div>
          <div class="columns mt-0 mb-0 pt-0 pb-0" v-if="deviceData.liveProcessingDeviceData && seacliffSet">
            <simple-tasks-info class="column" :tasks="deviceData.liveProcessingDeviceData.seacliffTasks" :property-set="seacliffSet" @onShowError="onShowError"/>
            <b-icon icon="arrow-right-thick" class="mt-auto mb-auto"></b-icon>
            <simple-tasks-info class="column" :tasks="deviceData.liveProcessingDeviceData.seacliffAgenAiTasks" :property-set="seacliffSet" @onShowError="onShowError"/>
            <b-icon icon="arrow-right-thick" class="mt-auto mb-auto" style="opacity: 0"></b-icon>
            <div class="column"></div>
          </div>
          <div class="columns mt-2 pt-0" v-if="deviceData.liveProcessingDeviceData && trafficLightSet">
            <simple-tasks-info class="column mt-0 pt-0" :tasks="deviceData.liveProcessingDeviceData.trafficLightTasks" :property-set="trafficLightSet" @onShowError="onShowError"/>
            <b-icon icon="arrow-right-thick" class="mt-auto mb-auto" style="opacity: 0"></b-icon>
            <div class="column mt-0 pt-0"></div>
            <b-icon icon="arrow-right-thick" class="mt-auto mb-auto" style="opacity: 0"></b-icon>
            <div class="column mt-0 pt-0"></div>
          </div>
          <div class="columns mt-2 pt-0" v-if="deviceData.liveProcessingDeviceData && motorcycleSet">
            <simple-tasks-info class="column mt-0 pt-0" :tasks="deviceData.liveProcessingDeviceData.motorcycleTasks" :property-set="motorcycleSet" @onShowError="onShowError"/>
            <b-icon icon="arrow-right-thick" class="mt-auto mb-auto" style="opacity: 0"></b-icon>
            <div class="column mt-0 pt-0"></div>
            <b-icon icon="arrow-right-thick" class="mt-auto mb-auto" style="opacity: 0"></b-icon>
            <div class="column mt-0 pt-0"></div>
          </div>

        </div>
      </div>
    </b-collapse>
  </div>

</template>

<script>
import {mapActions, mapGetters} from "vuex";
import TasksInfo from "@/modules/data-processing-tmc-module/components/data-processing-card/tasks-info.vue";
import FullValidationInfo
  from "@/modules/data-processing-tmc-module/components/data-processing-card/full-validation-info.vue";
import {
  isChooseModelEditOrAddAllowed,
  isEditOrAddAllowed,
  isPipelineEditOrAddAllowed,
  isProcessingEditOrAddAllowed
} from "@/utils/helper";
import LiveProcessingInfo
  from "@/modules/data-processing-tmc-module/components/data-processing-card/live-processing-info.vue";
import SimpleTasksInfo
  from "@/modules/data-processing-tmc-module/components/data-processing-card/simple-tasks-info.vue";

export default {
  name: "data-processing-card",
  components: {SimpleTasksInfo, LiveProcessingInfo, FullValidationInfo, TasksInfo},
  props: {
    deviceData: {
      type: Object
    },
    progress: {
      type: Number
    },
    progressStepOne: {
      type: Number
    },
    progressLive: {
      type: Number
    },
  },
  data() {
    return {
      isOpen: false
    }
  },
  methods: {
    isPipelineEditOrAddAllowed,
    isChooseModelEditOrAddAllowed,
    isProcessingEditOrAddAllowed,
    isEditOrAddAllowed,
    ...mapActions({
      setSelectedVideoCalibrations: 'dataProcessingTmcModule/setTmcSelectedVideoCalibrations',
      setSelectedProcessingDevice: 'dataProcessingTmcModule/setTmcSelectedProcessingDevice'
    }),
    getMessage() {
      if (this.allConditions()) {
        return 'This device has no tasks'
      } else {
        return 'Conditions missing'
      }
    },
    onTriggerBackProcessing(){
      this.$emit('onTriggerBackProcessing', this.deviceData)
    },
    isProcessingPeriodsExists() {
      return this.deviceData.processingPeriods && this.deviceData.processingPeriods.length > 0
    },
    onShowError(errors) {
      this.$emit('onShowError', errors)
    },
    setProgress(progress) {
      if (this.$refs.fullValidation) {
        this.$refs.fullValidation.setProgress(progress)
      }
    },
    setProgressStepOne(progress) {
      if (this.$refs.vehicleValidation) {
        this.$refs.vehicleValidation.setProgress(progress)
      }
    },
    setProgressLive(progress) {
      if (this.$refs.liveProcessing) {
        this.$refs.liveProcessing.setProgress(progress)
      }
    },
    onProcessingClick() {
      console.log('On processing click')
      this.$emit('onProcessingClick', this.deviceData)
    },
    onSetPipelineClick() {
      if (this.isVideoCalibrationExists()) {
        this.$emit('onCreatePipeline', this.deviceData)
      } else {
        this.showToast('Please create video config first', 'is-danger')
      }
    },
    onChooseModelClick() {
      console.log('On chooseModelClick')
      this.$emit('onChooseModelClick', this.deviceData)
    },
    onVideoCalibrationClick() {
      console.log('On Video calibration click: ', this.deviceData)
      this.setSelectedVideoCalibrations(this.deviceData.videoCalibrations)
      this.setSelectedProcessingDevice(this.deviceData)
      //this.$router.push('/video-calibration')

      const params = {
        projectId: this.selectedProcessingProject.project._id,
        dataDeviceId: this.deviceData._id
      }

      console.log('Params: ', params)

      this.$router.push({name: 'video-calibration-nearmiss', params: params})
    },
    onImportDataValidationClick() {
      console.log('On Video calibration click: ', this.deviceData)
      this.setSelectedVideoCalibrations(this.deviceData.videoCalibrations)
      this.setSelectedProcessingDevice(this.deviceData)
      //this.$router.push('/video-calibration')

      const params = {
        projectId: this.selectedProcessingProject.project._id,
        dataDeviceId: this.deviceData._id
      }

      console.log('Params: ', params)

      this.$router.push({name: 'import-data-validation-nearmiss', params: params})
    },
    showToast(message, type) {
      this.$buefy.toast.open({
        message: message,
        duration: 3000,
        type: type
      })
    },
    statusStyle() {
      if (this.deviceData.tasks && this.deviceData.tasks.status) {
        if (this.deviceData.tasks.status === 'CREATED') {
          return {background: '#8C84FF'}
        } else if (this.deviceData.tasks.status === 'RUNNING') {
          return {background: '#D8BA13'}
        } else if (this.deviceData.tasks.status === 'COMPLETED') {
          return {background: '#1CAB80'}
        }
      }
      return {background: '#000000'}
    },
    isVideoCalibrationExists() {
      if (this.deviceData.videoCalibrations && this.deviceData.videoCalibrations.length > 0) {
        if (this.deviceData.videoCalibrations.filter(calibration => calibration.status === 'active').length > 0) {
          return true
        }
      }
      return false
    },
    isDataValidationExists() {
      if (this.deviceData.directionLookup && this.deviceData.validationData) {
        return true
      }
      return false
    },
    allConditions() {
      return this.isVideoCalibrationExists() && this.deviceData.processingPeriods && this.deviceData.processingPeriods.length > 0
    },
    onAddTasksClick() {
      console.log('On Add task clicked')
      this.$emit('onAddTasksClick', this.deviceData)
    },
    onRunTasksClick() {
      console.log('On Run task clicked')
      this.$emit('onRunTasksClick', this.deviceData)
    },
    onRunTasksVehProcessingClick() {
      console.log('On Run task clicked')
      this.$emit('onRunTasksVehicleProcessingClick', this.deviceData)
    },
    onRunInitialValidation() {
      this.$emit('onRunInitialValidation', this.deviceData)
    },
    onRunFullProcessing() {
      this.$emit('onRunFullProcessing', this.deviceData)
    },
    onRunPedestrianProcessing() {
      this.$emit('onRunPedestrianProcessing', this.deviceData)
    },
    onShowInitialResults() {
      this.$emit('onShowInitialResults', this.deviceData)
    },
    onShowFullResults() {
      this.$emit('onShowFullResults', this.deviceData)
    },
    onResetStep(stepName) {
      this.$emit('onResetStep', {stepName: stepName, dataDeviceId: this.deviceData._id})
    }
  },
  computed: {
    ...mapGetters({
      selectedProcessingProject: 'dataProcessingTmcModule/getTmcSelectedProcessingProject',
      selectedDevice: 'dataProcessingTmcModule/getTmcSelectedProcessingDevice'
    }),
    isLiveMonitoring() {
      return this.deviceData.dataRequired != null
    },
    lyraSet(){
      return this.deviceData && this.deviceData.dataRequired && this.deviceData.dataRequired.ai && this.deviceData.dataRequired.ai.includes('lyra')
    },
    yoloSet(){
      return this.deviceData && this.deviceData.dataRequired && this.deviceData.dataRequired.ai && this.deviceData.dataRequired.ai.includes('yolo')
    },
    seacliffSet(){
      return this.deviceData && this.deviceData.dataRequired && this.deviceData.dataRequired.ai && this.deviceData.dataRequired.ai.includes('seacliff')
    },
    trafficLightSet(){
      return this.deviceData && this.deviceData.dataRequired && this.deviceData.dataRequired.ai && this.deviceData.dataRequired.ai.includes('traffic-light')
    },
    motorcycleSet(){
      return this.deviceData && this.deviceData.dataRequired && this.deviceData.dataRequired.ai && this.deviceData.dataRequired.ai.includes('motorcycle')
    },
    velaSet(){
      return this.deviceData && this.deviceData.dataRequired && this.deviceData.dataRequired.data && (this.deviceData.dataRequired.data.includes('vela_with_lyra') || this.deviceData.dataRequired.data.includes('vela_with_yolo'))
    },
    eventProcessingSet(){
      return this.deviceData && this.deviceData.dataRequired && this.deviceData.dataRequired.events && (this.deviceData.dataRequired.events.includes('near_miss') || this.deviceData.dataRequired.events.includes('dtp'))
    },
    numOfConditionedFiles(){
      if(this.deviceData && this.deviceData.liveProcessingDeviceData){
        return this.deviceData.liveProcessingDeviceData.numberOfConditionedFiles
      }
      return 'N/A'
    },
    latestFileTime(){
      if(this.deviceData && this.deviceData.liveProcessingDeviceData && this.deviceData.liveProcessingDeviceData.latestFileStartTimeLocal){
        const [datePart, timePart] = this.deviceData.liveProcessingDeviceData.latestFileStartTimeLocal.split("T");
        const [year, month, day] = datePart.split("-");
        const time = timePart.substring(0, 8);

        return `${day}.${month}.${year} ${time}`
      }
      return 'Unknown'
    }
  },
  watch: {
    progress: {
      handler: function (after, before) {
        this.setProgress(after)
      },
      deep: true
    },
    progressStepOne: {
      handler: function (after, before) {
        this.setProgressStepOne(after)
      },
      deep: true
    },
    progressLive: {
      handler: function (after, before) {
        this.setProgressLive(after)
      },
      deep: true
    },
    refresh: {
      handler: function (after, before) {
        //this.setRefreshing(after)
      },
      deep: true
    }
  }
}
</script>

<style scoped lang="scss">

.card-header-title {
  align-items: center;
  color: hsl(0deg, 0%, 21%);
  flex-grow: 1;
  font-weight: 700;
  padding: 0;
}

.card-shadow {
  box-shadow: 0 0.125em 0.125em -0.125em rgb(10 10 10 / 10%), 0 0px 0 1px rgb(10 10 10 / 2%);
  background-color: white;
  border-radius: 0.35rem;
}

.clickable-info {
  opacity: 0.5;
  background: #f4f4f4;
  border-radius: 0.3rem;
}

.clickable-info-editable {
  background: #f4f4f4;
  border-radius: 0.3rem;
}

.clickable-info:hover {
  cursor: pointer;
  box-shadow: 0 0.125em 0.125em -0.125em rgb(10 10 10 / 20%), 0 0px 0 1px rgb(10 10 10 / 5%);
  background: #e7e7e7;
  opacity: 0.5;
}

.clickable-info-editable:hover {
  cursor: pointer;
  box-shadow: 0 0.125em 0.125em -0.125em rgb(10 10 10 / 20%), 0 0px 0 1px rgb(10 10 10 / 5%);
  background: #e7e7e7;
}

.clickable:hover {
  cursor: pointer;
}

.dashed-border-small {
  padding: 8px 8px;
  border-style: dashed;
  border-radius: 8px;
  border-width: 1px;
  border-color: rgba(0, 0, 0, 0.1);
}
</style>